import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { createRoot } from 'react-dom/client'
import i18n from 'i18next'; // Importa a instância do i18n

const MySwal = withReactContent(Swal)

class MessageService {
  error(title: string, onConfirm?: () => void, allowOutsideClick = true) {
    MySwal.fire({
      title: title,
      icon: 'error',
      allowOutsideClick
    }).then((value: any) => {
      if (value.isConfirmed && onConfirm) {
        onConfirm()
      }
    })
  }

  errorWithDetail(title: string, text: string, onConfirm?: () => void, allowOutsideClick = true) {
    MySwal.fire({
      title: title,
      text: text,
      icon: 'error',
      allowOutsideClick
    }).then((value: any) => {
      if (value.isConfirmed && onConfirm) {
        onConfirm()
      }
    })
  }

  success(title: string, text: string, onConfirm?: () => void, timer?: number, options?: any) {
    console.info(title)
    MySwal.fire({
      title: title,
      showCancelButton: false,
      text: text,
      icon: 'success',
      timer: timer,
      ...options
    }).then((value: any) => {
      if (value.isConfirmed && onConfirm) {
        onConfirm()
      }
    })
  }

  warn(title: string, text: string, onConfirm?: () => void, timer?: number, options?: any) {
    console.info(title)
    MySwal.fire({
      title: title,
      showCancelButton: false,
      text: text,
      icon: 'warning',
      timer: timer,
      ...options
    }).then((value: any) => {
      if (value.isConfirmed && onConfirm) {
        onConfirm()
      }
    })
  }

  confirm(title: string, text: string, onConfirm?: (params?: any) => void, onCancel?: (params?: any) => void, textoBotaoConfirmacao?: string) {
    // Busca a tradução ou usa fallback
    const confirmBtnText = textoBotaoConfirmacao || i18n.t('botoes.confirmar', 'Confirmar');
    const cancelBtnText = i18n.t('botoes.cancelar', 'Cancelar');

    MySwal.fire({
      title: title,
      showCancelButton: true,
      text: text,
      icon: 'warning',
      confirmButtonText: confirmBtnText,
      cancelButtonText: cancelBtnText
    }).then((value: any) => {
      if (value.isConfirmed && onConfirm) {
        onConfirm()
      } else if (onCancel) {
        onCancel()
      }
    })
  }

  onlyConfirm(title: string, text: string, onConfirm?: (params?: any) => void, textoBotaoConfirmacao?: string) {
    const confirmBtnText = textoBotaoConfirmacao || i18n.t('botoes.confirmar', 'Confirmar');

    MySwal.fire({
      title: title,
      text: text,
      icon: 'warning',
      showCloseButton: true,
      confirmButtonText: confirmBtnText
    }).then((value: any) => {
      if (value.isConfirmed && onConfirm) {
        onConfirm()
      } 
    })
  }

  simNaoConfirm(title: string, text: string, onSim?: (params?: any) => void, onNao?: (params?: any) => void, textoBotaoConfirmacao?: string, textoBotaoCancelamento?: string, html:any ='') {
    console.info(title)
    
    const simText = textoBotaoConfirmacao || i18n.t('botoes.sim', 'Sim');
    const naoText = textoBotaoCancelamento || i18n.t('botoes.nao', 'Não');

    MySwal.fire({
      title: title,
      showCancelButton: true,
      text: text,
      html: html,
      icon: 'warning',
      confirmButtonText: simText,
      cancelButtonText: naoText
    }).then((value: any) => {
      if (value.isConfirmed && onSim) {
        onSim()
      } else if (value.isDismissed && onNao) {
        onNao()
      }
    })
  }

  infoWithHtml(title: string, html: string, onConfirm?: () => void) {
    MySwal.fire({
      title: title,
      icon: 'info',
      html: html
    }).then((value: any) => {
      if (value.isConfirmed && onConfirm) {
        onConfirm()
      }
    })
  }

  infoWithComponent(title: string, component: React.ReactNode, onConfirm?: () => void) {
    MySwal.fire({
      width: 600,
      title: title,
      icon: 'info',
      html: '<div id="container"></div>',
      didOpen: () => {
        const container = document.getElementById("container")
        if (container) {
          createRoot(container).render(component)
        }
      }
    }).then((value: any) => {
      if (value.isConfirmed && onConfirm) {
        onConfirm()
      }
    })
  }

  duasOpcoes(title: string, text: string, onPrimeira?: (params?: any) => void, onSegunda?: (params?: any) => void, textoBotaoPrimeira?: string, textoBotaoSegunda?: string, html:any ='') {
    
    const btnUm = textoBotaoPrimeira || i18n.t('botoes.sim', 'Sim');
    const btnDois = textoBotaoSegunda || i18n.t('botoes.nao', 'Não');

    MySwal.fire({
      title: title,
      showCancelButton: true,
      text: text,
      icon: 'warning',
      html: html,
      confirmButtonText: btnUm,
      cancelButtonText: btnDois
    }).then((value: any) => {
      if (value.isConfirmed && onPrimeira) {
        onPrimeira();
      } else if (value.isDismissed && onSegunda) {
        onSegunda();
      }
    });
  }

  showAlert(title: string, text: string) {
    MySwal.fire({title: title, text: text})
  }
  
}

export const messageService = new MessageService()